<template>
  <div>
    <v-alert v-model="escalation" prominent dense transition="scroll-y-transition" type="error" class="my-0">
      <v-row no-gutters align="center">
        <v-col class="grow">
          <span class="subtitle-1 font-weight-bold">Escalation:</span>
          {{escalationData.text | notEmpty}}
          <span class="subtitle-1 font-weight-bold ml-4">Created:</span>
          {{escalationData.creation_timestamp | formatDate('YYYY-MM-DD')}}
        </v-col>
        <v-col class="shrink">
          <v-btn light class="remove-button" @click="removeEscalation">Remove</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      moment,
      escalation: false,
      escalationData: {},
    }
  },
  filters: {
    notEmpty: function(val) {
      return (val === null || val === "" || val === undefined)?'-':val;
    },
  },
  watch: {
    accountEscalation(newData) {
      if (newData && Object.keys(newData).length !== 0) {
        this.escalation = true;
        this.escalationData = this.accountEscalation;
      }
    }
  },

  computed: {
    ...mapState("accounts", ["currentAccount","currentAccountLoading","accountEscalation","creditData","creditDataLoading"]),
  },

  methods: {
    ...mapActions("accounts", ["removeAccountEscalation"]),

    removeEscalation() {
      this.removeAccountEscalation(this.$route.params.id);
      this.escalation = false;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
